// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives',
)({
  component: Outlet,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'energyxplorer:app_bar.initiatives' },
});
